import { useState } from "react";
import { toast } from "sonner";
import { Instagram } from "lucide-react";
import { api } from "@/lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) { toast.error("Introdu o adresă de e-mail validă."); return; }
    setLoading(true);
    try { const res = await api.newsletter(email); toast.success(res.message); setEmail(""); }
    catch { toast.error("A apărut o eroare. Încearcă din nou."); }
    setLoading(false);
  };

  const cols = [
    { title: "ORÉLIE", links: ["Despre noi", "Contact"] },
    { title: "Informații", links: ["Termeni și condiții", "Politica de confidențialitate", "Livrare și retur"] },
  ];

  return (
    <footer data-testid="footer" className="relative bg-footer text-[#E5DDD0] pt-20 pb-10 grain overflow-hidden border-t-2 border-mocha/40 shadow-[0_-26px_70px_-34px_rgba(28,24,22,0.7)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 pb-16 border-b border-white/10">
          <div className="lg:col-span-4">
            <p className="font-serif text-4xl tracking-[0.15em] text-cream" style={{ textShadow: "0 2px 24px rgba(0,0,0,0.5)" }}>ORÉLIE</p>
            <p className="eyebrow text-[#E4C58A] mt-1 tracking-[0.35em]">Haute Parfumerie</p>
            <p className="text-[#DACEBC] text-sm leading-relaxed mt-6 max-w-xs">
              Parfumuri persistente create pentru cei care caută rafinamentul absolut și eleganța atemporală.
            </p>
            <div className="flex gap-3 mt-8">
              {[Instagram].map((Icon, i) => (
                <a key="instagram" href="https://www.instagram.com/alex_crs_345/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid={`social-link-${i}`}
                  className="w-10 h-10 flex items-center justify-center border border-white/15 text-[#E5DDD0] hover:bg-mocha hover:text-footer hover:border-mocha transition-all duration-400">
                  <Icon size={16} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="lg:col-span-2">
              <p className="font-serif text-xl text-[#E4C58A] mb-5" style={{ textShadow: "0 1px 12px rgba(0,0,0,0.4)" }}>{c.title}</p>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l}><a href="#" className="text-sm text-[#D3C7B5] hover:text-cream transition-colors">{l}</a></li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-4">
            <p className="font-serif text-2xl text-[#E4C58A] mb-3" style={{ textShadow: "0 1px 12px rgba(0,0,0,0.4)" }}>Abonează-te la ORÉLIE</p>
            <p className="text-[#DACEBC] text-sm leading-relaxed mb-5">
              Primește invitații exclusive la lansări private de parfumuri și noutăți olfactive.
            </p>
            <form onSubmit={subscribe} data-testid="newsletter-form" className="flex border border-white/15 focus-within:border-mocha transition-colors">
              <input data-testid="newsletter-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Adresa ta de e-mail..." className="flex-1 bg-transparent px-4 py-3.5 text-sm text-cream placeholder:text-[#8A7E75] outline-none" />
              <button data-testid="newsletter-submit" disabled={loading}
                className="px-6 bg-mocha text-footer text-xs uppercase tracking-widest hover:bg-cream transition-colors disabled:opacity-60">
                {loading ? "..." : "Abonare"}
              </button>
            </form>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-[#A99D8E] text-xs">Toate drepturile rezervate © 2026 ORÉLIE Parfums.</p>
          <div className="flex gap-6">
            <a href="#" className="text-[#A99D8E] text-xs hover:text-cream transition-colors">Termeni și condiții</a>
            <a href="#" className="text-[#A99D8E] text-xs hover:text-cream transition-colors">Politica de confidențialitate</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
